import RestApiModel from "@/api/Model/RestApiModel";
import api from "../index";

class CompanyAddress extends RestApiModel {
  static getResourceEndpoint() {
    return '/companies/addresses';
  }

  static setPrimary(id ) {
    return api.patch(this.getResourceIdEndpoint(id, 'set-as-primary'));
  }

  static getOptions() {
    return api.get(this.getResourceEndpoint() + '/options');
  }

}

export default CompanyAddress;
